export default {
  state: {
    search: null
  },
  mutations: {
    setSearch (state, payload) {
      state.user = payload
    }
  },
  actions: {
    addSearch ({commit}, newSearch) {
      commit('setSearch', newSearch)
    },
    logout ({commit}) {
      commit('setUser', null)
    }
  },
  getters: {
    getSearch: state => state.search
  }
}



// WEBPACK FOOTER //
// ./src/store/search/index.js